const TAG_BASE_ROUTE = '/tag';

export const TAG_API_ROUTES = {
  index: () => TAG_BASE_ROUTE,
  deepLink: (deeplink: string) => `${TAG_BASE_ROUTE}/${deeplink}`,
  userTags: () => `${TAG_BASE_ROUTE}/user-tags`,
  delete: () => `${TAG_BASE_ROUTE}/delete`,
  updateTag: (userTagId: string) => `${TAG_BASE_ROUTE}/${userTagId}`,
} as const;
